import {
  CREATELEADCASE,
  GETLEADCASE,
  DELETELEADCASE,
  UPDATELEADCASE,
} from "../actions/types";

const initialState = {
  leadCaseList: [], 
  leadCaseUpdateStatus: null,
  leadCaseDeleteStatus: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GETLEADCASE:
      return {
        ...state,
        leadCaseList: action.payload.data 
      };
    case UPDATELEADCASE:
      return {
        ...state,
        leadCaseUpdateStatus: action.payload.success,
      };

    case DELETELEADCASE:
      return {
        ...state,
        leadCaseDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}